import React, { useEffect, useState } from "react";
import { Breadcrumb, Container, Row, Col } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { MyApi } from "../MyApi";
import useSEO from "../hooks/useSEO";

export default function BlogDetails() {
  const { slug } = useParams();

  const [blog, setBlog] = useState(null);
  const [related, setRelated] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const res = await axios.get(
          MyApi.BASE_URL + MyApi.BLOGDETAILS + "/" + slug,
          {
            headers: { Authorization: MyApi.SECRET_KEY },
          }
        );

        if (res.data.status) {
          setBlog(res.data.data);
          setRelated(res.data.related || []);
        }
      } catch (err) {
        console.error("Blog Details Error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [slug]);

  // ✅ SEO
  useSEO({
    title: blog?.meta_title || blog?.categoryname || "Blog Details",
    description: blog?.meta_description || "",
    keywords: blog?.meta_tags || "",
    canonical: window.location.href,
    ogImage: blog?.image_url || "",
  });

  if (loading)
    return (
      <Container className="py-5 text-center">
        <p>Loading blog details...</p>
      </Container>
    );

  if (!blog)
    return (
      <Container className="py-5 text-center">
        <h2>Blog Not Found</h2>
      </Container>
    );

  return (
    <div>
      {/* Breadcrumb */}
      <div className="BreadcrumbStyle">
        <Container>
          <h1>{blog.categoryname}</h1>
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/blog" }}>
              Blog
            </Breadcrumb.Item>
            <Breadcrumb.Item active>{blog.categoryname}</Breadcrumb.Item>
          </Breadcrumb>
        </Container>
      </div>

      <Container className="py-5">
        <Row>
          {/* LEFT: BLOG CONTENT */}
          <Col md={12}>
            <Link to="/blog" className="btn btn-secondary mb-3">
              ← Back to Blog
            </Link>

            {/* Image */}
            <img
              src={blog.image_url}
              alt={blog.categoryname}
              className="img-fluid mb-4 rounded"
              onError={(e) => {
                e.target.src = "/no-image.png";
              }}
            />

            {/* Date */}
            <p className="text-muted">
              {blog?.created_on &&
                new Date(blog.created_on).toLocaleDateString("en-IN", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })}
            </p>

            {/* Content */}
            <div
              dangerouslySetInnerHTML={{
                __html: blog.categoryshortcontent || "",
              }}
            />
          </Col>

          {/* RIGHT: RELATED BLOGS */}
          {/* <Col md={4}>
          
            <h4 className="mb-3">Related Blogs</h4>

            {related.length === 0 && <p>No related blogs</p>}

            {related.map((item, index) => (
              <Card className="mb-3 shadow-sm" key={index}>
                <Link
                  to={`/blog/${item.slug}`}
                  className="text-decoration-none text-dark"
                >
                  <Card.Img
                    variant="top"
                    src={item.image_url}
                    onError={(e) => {
                      e.target.src = "/no-image.png";
                    }}
                  />
                  <Card.Body>
                    <Card.Title style={{ fontSize: "16px" }}>
                      {item.categoryname}
                    </Card.Title>
                  </Card.Body>
                </Link>
              </Card>
            ))}
          </Col> */}
        </Row>
      </Container>
    </div>
  );
}